import * as React from 'react';
import { PORTAL_NAME } from './constants';
import { PortalProvider, useDialogContext } from './context';
import { Portal } from '../../internal/components/Portal';
import { Presence } from '../../internal/components/Presence';
import { jsx as _jsx } from "react/jsx-runtime";
export const DialogPortal = props => {
  const {
    __scopeDialog,
    forceMount,
    children,
    container
  } = props;
  const context = useDialogContext(PORTAL_NAME, __scopeDialog);
  return /*#__PURE__*/_jsx(PortalProvider, {
    scope: __scopeDialog,
    forceMount: forceMount,
    children: React.Children.map(children, child => /*#__PURE__*/_jsx(Presence, {
      present: forceMount || context.open,
      children: /*#__PURE__*/_jsx(Portal, {
        asChild: true,
        container: container,
        children: child
      })
    }))
  });
};
DialogPortal.displayName = PORTAL_NAME;